/**
 * Best-effort web-side bind of the HttpOnly attribution cookie.
 * Failures are ignored so signup and checkout never depend on it.
 */
export async function linkInstallAttributionFromCookie(
  accessToken: string
): Promise<void> {
  const trimmed = accessToken.trim();
  if (!trimmed) return;
  try {
    await fetch("/api/nrs/install-attribution/link-from-cookie", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Authorization: `Bearer ${trimmed}`,
        Accept: "application/json",
      },
    });
  } catch {
    // Backup path only.
  }
}
